export default class IfIe {
    constructor(el) {
        this.el = el;
        this.init();
    }
    init() {
        if(navigator.userAgent.indexOf('MSIE')!==-1
            || navigator.appVersion.indexOf('Trident/') > -1){
            /* Microsoft Internet Explorer detected in. */
            // this.el.style = '';
        }
    }
}